import { render } from "./Logo.vue?vue&type=template&id=2e252eaa&scoped=true&ts=true"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"

import "./Logo.vue?vue&type=style&index=0&id=2e252eaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e252eaa"]])

export default __exports__